export default {
      id: "as-accessible-changing-room-usage",
      viewBox: "0 0 56 56",
      url: "/" + "sprite.svg#as-accessible-changing-room",
      toString: function () {
        return this.url;
      }
    }